import { render, staticRenderFns } from "./brandDetails.vue?vue&type=template&id=a8bc6f06&scoped=true"
import script from "./brandDetails.vue?vue&type=script&lang=js"
export * from "./brandDetails.vue?vue&type=script&lang=js"
import style0 from "./brandDetails.vue?vue&type=style&index=0&id=a8bc6f06&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8bc6f06",
  null
  
)

export default component.exports